<template>
  <el-dialog v-dialogDrag
             ref="reLogin"
             id="reLogin"
             title="账号登录"
             :visible.sync="reLoginDialogVisible"
             width="30%"
             :modal="false"
             center
  >
    <el-form :model="loginData"
             ref="loginForm"
             :rules="loginRules">
      <el-form-item prop="username" label="账号">
        <el-input type="text"  v-model="loginData.username" auto-complete="off" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password" >
        <el-input type="password"
                  v-model="loginData.password"
                  auto-complete="off"
                  placeholder="请输入密码"
                  @keyup.enter="startLogin('loginForm')">
        </el-input>
      </el-form-item>
      <el-form-item style="width:100%;text-align:center">
        <el-button type="primary" style="width:100%;"  @click="startLogin('loginForm')">登录</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {getUserInfo} from "../../api/api";

export default {
  name: "reloginPage",
  data() {
    return {
      reLoginDialogVisible: true,
      loginData: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [
          {required: true, message: "请输入账号", trigger: "blur"}
        ],
        password: [
          {required: true, message: "请输入密码", trigger: "blur"}
        ]
      },
    }
  },
  methods:{
    startLogin(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          sessionStorage.setItem("go", true);
          this.$axios.post("/login", this.loginData).then(res => {
            if (res.data.success === false) {
              this.$message.error(res.data.errorMsg);
              return false;
            }

            this.$cookies.set('access_token', res.headers.authorization);
            this.getSysAdmin();
          }).catch(err => {
            this.$message('登录出错，请重试！')
          })
        } else {
          this.$message('请输入账号密码')
          return false;
        }
      });

    },
    //获取菜单列表
    getSysAdmin() {
      getUserInfo({}).then((res) => {
        if (res) {
          let oldData = JSON.parse(sessionStorage.getItem("sysUserName"));

          //判断登录是否同一个人，非同一个人强制弹至登录页面重新登录
          if(res.password !== oldData.password || res.staff_name !== oldData.staff_name){
            location.href ='https://huayang-in.com/hybb/#/loginForm'
            sessionStorage.clear();
            localStorage.clear();
          }

          this.reLoginDialogVisible = false;
        }
      }).catch((res) => {
        this.$message("查询用户名异常");
      });
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// reloginPage.vue?c6095784